<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  export let onClear: any;
  export let onClose: any;
  export let selectedFiltersLength: number;

</script>

<div class="fizz-border-top fizz-border-bottom fizz-inset-vertical-16" data-testid="filters-header">
  <div class="fizz-flex-row fizz-space-between">
    <div class="fizz-flex-row">
      <Icon width="16" height="16" type="Filter2" />
      <span class="fizz-heading-4">Filters</span>
    </div>
    {#if $LayoutStore.isMobile}
      <button data-testid="close-filters" on:click={onClose}>
        <Icon width="16" height="16" type="X" />
      </button>
    {:else if selectedFiltersLength > 0}
      <span
        class="cursor-pointer fizz-text-medium fizz-text-subdued fizz-text-regular underline-hover"
        on:click={onClear}
        data-testid="clear-all-filters"
      >
        Clear
      </span>
    {/if}
  </div>
</div>
